import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'
import { useState } from 'react'

type Props = {
  imageWidth: number
  imageHeight: number
  hoverImagePath: string
  defaultImagePath: string
}

export const HoverToggleImage = ({
  imageWidth,
  imageHeight,
  hoverImagePath,
  defaultImagePath,
}: Props): JSX.Element => {
  const [isHover, setIsHover] = useState(false)
  return (
    <div
      className="relative w-full"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        className={`absolute w-full transition-opacity ${
          isHover ? 'opacity-100 duration-100' : 'opacity-0 duration-300'
        }`}
      >
        <ImageWraper
          src={`${cloudfrontPath}${hoverImagePath}`}
          width={imageWidth}
          height={imageHeight}
        />
      </div>
      <div
        className={`absolute w-full transition-opacity ${
          isHover ? 'opacity-0 duration-300' : 'opacity-100 duration-100'
        }`}
      >
        <ImageWraper
          src={`${cloudfrontPath}${defaultImagePath}`}
          width={imageWidth}
          height={imageHeight}
        />
      </div>
    </div>
  )
}
